import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { refreshMe } from "@/lib/userAuth";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("polling");
  const [record, setRecord] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    const poll = async () => {
      attempts.current += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setRecord(r.data);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          await refreshMe();
        } else if (attempts.current > 15) {
          setStatus("timeout");
        } else {
          setTimeout(poll, 2000);
        }
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [params]);

  return (
    <div className="max-w-lg mx-auto px-6 py-16 text-center">
      {status === "polling" && (
        <div data-testid="payment-polling">
          <Loader2 className="w-16 h-16 animate-spin text-labor-olive mx-auto mb-6" />
          <h1 className="font-display text-3xl">Verifica pagamento…</h1>
          <p className="text-labor-muted mt-2">Attendi qualche secondo, stiamo confermando la tua ricarica.</p>
        </div>
      )}
      {status === "paid" && (
        <div data-testid="payment-success">
          <div className="w-20 h-20 bg-labor-olive text-white mx-auto flex items-center justify-center mb-6 rounded-full">
            <CheckCircle2 className="w-12 h-12" />
          </div>
          <h1 className="font-display text-3xl">Pagamento riuscito!</h1>
          <p className="text-labor-muted mt-3">
            Sono stati accreditati <strong>{record?.labor_points} Labor Point</strong> sul tuo account.
          </p>
          <div className="mt-6 flex gap-3 justify-center flex-wrap">
            <button onClick={() => nav("/profilo")} className="olive-btn px-6 py-3 font-semibold">Vai al profilo</button>
            <Link to="/" className="border border-labor-border px-6 py-3 font-semibold">Home</Link>
          </div>
        </div>
      )}
      {(status === "timeout" || status === "error") && (
        <div data-testid="payment-error">
          <XCircle className="w-16 h-16 text-labor-terracotta mx-auto mb-6" />
          <h1 className="font-display text-3xl">Non riesco a confermare il pagamento</h1>
          <p className="text-labor-muted mt-3">
            Il pagamento potrebbe essere ancora in elaborazione. Vai al profilo per verificare il tuo saldo.
          </p>
          <button onClick={() => nav("/profilo")} className="olive-btn mt-6 px-6 py-3 font-semibold">Vai al profilo</button>
        </div>
      )}
    </div>
  );
}
